import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-app-sidebar-drawer',
    templateUrl: './sidebar-drawer.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppSidebarDrawerComponent {
    @Input() isExpanded = false;
    @HostBinding() class = 'eui-app-sidebar-drawer';

    constructor() {}

    @HostBinding('class')
    public get cssClasses(): any {
        return this._getCssClasses();
    }

    private _getCssClasses() {
        return [
            `eui-app-sidebar-drawer`,
            this.isExpanded ? 'eui-app-sidebar-drawer--expanded' : '',
        ].join(' ').trim();
    }
}
